import Box from '@mui/material/Box';
import { HTMLAttributes, ReactElement } from 'react';

interface IOption {
  createItemIcon?: ReactElement | null;
  itemIcon?: ReactElement | null;
  newItemId: number | string;
  newItemId2?: number | string;
  option: { id?: number | string; [key: string]: unknown };
  optionLabelKey: string;
  renderProps: HTMLAttributes<HTMLLIElement>;
}

function Option({
  createItemIcon = null,
  itemIcon = null,
  newItemId,
  newItemId2 = '',
  option,
  optionLabelKey,
  renderProps,
}: IOption) {
  const isNewItem = option.id === newItemId;
  const isNewItemId2 = option.id === newItemId2;

  return (
    <Box
      component="li"
      key={option.id}
      sx={{ color: isNewItem || isNewItemId2 ? 'primary.main' : 'text.primary' }}
      {...renderProps}
    >
      {isNewItem || isNewItemId2 ? createItemIcon : itemIcon}
      <Box
        sx={{
          pl: ((isNewItem || isNewItemId2) && createItemIcon) || ((!isNewItem || !isNewItemId2) && itemIcon) ? 2 : 0,
        }}
      >
        {(option?.[optionLabelKey] as string) || ''}
      </Box>
    </Box>
  );
}

export default Option;
